import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface UserOnboardingState {
  dpi?: string
  employeeNumber?: number
  agencyId?: number
  isFirstAccess?: boolean
  userInformationId?: number
  pin?: string
}

const initialState: UserOnboardingState = {}

const userOnboardingSlice = createSlice({
  name: 'userOnboarding',
  initialState,
  reducers: {
    setUserInformation(
      state,
      action: PayloadAction<{
        dpi: string
        employeeNumber: number
        agencyId: number
        isFirstAccess: boolean
        userInformationId: number
      }>,
    ) {
      state.dpi = action.payload.dpi
      state.employeeNumber = action.payload.employeeNumber
      state.agencyId = action.payload.agencyId
      state.isFirstAccess = action.payload.isFirstAccess
      state.userInformationId = action.payload.userInformationId
    },
    setPin(state, action: PayloadAction<string>) {
      state.pin = action.payload
    },
    clearOnboarding(state) {
      state.employeeNumber = undefined
      state.agencyId = undefined
      state.isFirstAccess = undefined
      state.userInformationId = undefined
      state.pin = undefined
    },
  },
})

export const { setUserInformation, setPin, clearOnboarding } =
  userOnboardingSlice.actions
export default userOnboardingSlice.reducer
export type { UserOnboardingState }
